import axios from 'axios'
import { getHeaderUploadFile, queryBuilder, urlMapper } from '../helpers/utility'

const authPostFormData = ({ url = '', query = {}, body = {}, params = {}, headers = {} }) => {
  const formData = new FormData()
  formData.append('file', body.file)
  const queryString = queryBuilder(query)
  const mappedUrl = urlMapper(url, params)
  const combinedUrl = `${mappedUrl}${queryString}`
  return axios
    .post(combinedUrl, formData, {
      headers: {
        ...getHeaderUploadFile(),
        ...headers
      }
    })
    .catch(error => {
      if (error.response) {
        throw error.response
      } else {
        throw error
      }
    })
    .then(response => {
      return response
    })
}

export default authPostFormData
